
/* styles */
require("!!../../../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-e9864fec!../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./RegistrationStatusLabel.vue")

var Component = require("!../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./RegistrationStatusLabel.vue"),
  /* template */
  require("!!../../../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-e9864fec!../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./RegistrationStatusLabel.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/domains/event/components/show/labels/RegistrationStatusLabel.vue
// module id = 257
// module chunks = 2